import { useTranslation } from "react-i18next"

import { SectionHeading } from "../components/SectionHeading"
import { BODY, CONTAINER, SECTION_SOFT } from "../components/styles"
import { ANCHORS, SITE } from "../site-config"

/** 常见问题：原生 details 折叠，无需额外 JS */
export function FaqSection() {
  const { t } = useTranslation()

  const items = [
    { q: t("official_faq_q1"), a: t("official_faq_a1") },
    { q: t("official_faq_q2"), a: t("official_faq_a2") },
    { q: t("official_faq_q3"), a: t("official_faq_a3") },
    { q: t("official_faq_q4"), a: t("official_faq_a4") },
    { q: t("official_faq_q5"), a: t("official_faq_a5") },
    {
      q: t("official_faq_q6"),
      a: t("official_faq_a6", { email: SITE.privacyEmail }),
    },
  ]

  return (
    <section id={ANCHORS.faq} className={`${SECTION_SOFT} scroll-mt-[68px]`}>
      <div className={CONTAINER}>
        <SectionHeading
          eyebrow={t("official_faq_eyebrow")}
          title={t("official_faq_title")}
        />

        <div className="grid max-w-[800px] gap-3">
          {items.map((item) => (
            <details
              key={item.q}
              className="rounded-[14px] border border-line bg-white px-5 py-4 open:shadow-card"
            >
              <summary className="cursor-pointer list-none text-base font-semibold text-ink marker:hidden [&::-webkit-details-marker]:hidden">
                {item.q}
              </summary>
              <p className={`mt-3 ${BODY}`}>{item.a}</p>
            </details>
          ))}
        </div>
      </div>
    </section>
  )
}
